import cx from 'classnames'

import { CommentIcon } from '../../../../../assets/svgs/components'

import styles from './commentView.module.scss'

export function CommentView ({ item, selected }) {
  const commentCounter = item?.comment?.filter(c => c.unread)?.length
  const isDraft = item?.comment?.some(c => c.draft)

  const color = () => {
    if (isDraft && selected) {
      return '#72A300'
    }
    return selected ? '#7728ff' : 'black'
  }

  return (
    <div className={styles.wrapper}>
      <CommentIcon fill={color()} />
      {commentCounter > 0 && (
        <div className={cx(styles.commentCounter, { [styles.draft]: isDraft })}>
          <span>{commentCounter}</span>
        </div>
      )}
    </div>
  )
}
